/**
 * Bomu Labs — Hero slideshow.
 * Slides sit stacked (absolutely positioned) and cross-fade into each other
 * on a slow, fixed interval. No manual controls by design — this is meant
 * to feel like an ambient background, not an interactive carousel.
 *
 * Respects prefers-reduced-motion: slides still advance (so images actually
 * rotate), but the fade transition is skipped in favour of an instant swap.
 */
class BomuHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.bomu-hero-slide'));
    if (this.slides.length <= 1) return;

    const intervalMs = parseInt(this.dataset.intervalMs, 10) || 30000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      this.classList.add('bomu-hero-slideshow--instant');
    }

    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.currentIndex === -1) this.currentIndex = 0;

    this.timer = setInterval(() => this._advance(), intervalMs);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  _advance() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.slides[this.currentIndex].classList.remove('is-active');
    this.slides[nextIndex].classList.add('is-active');
    this.currentIndex = nextIndex;
  }
}

customElements.define('bomu-hero-slideshow', BomuHeroSlideshow);
